"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendValidationCode = sendValidationCode;
var _sendValidationCode = require("../repositories/sms/v2/send-validation-code");
function sendValidationCode(httpApi, phone) {
  return (0, _sendValidationCode.fetchSendValidationCode)({
    httpApi,
    parameters: {
      phone,
      type: _sendValidationCode.EType.AuthenticateCode
    },
    config: {
      requestConfig: {
        headers: [['Content-Type', 'application/json']]
      }
    }
  });
}